import React, { useEffect, useState, useRef } from "react";
import {
  Layout,
  Container,
  DesignWrapper,
  Title,
  Desc,
  Help,
  CodeContainer,
  CodeBox,
  Action,
  CodeCopy,
  Close,
} from "./styles";
import VoucherGraphic from "./Design";
import StyledLink from "../../UIcomponent/Link";
import { ReactComponent as CopyIcon } from "../../Assets/icon/copy.svg";
import { ReactComponent as CloseIcon } from "../../Assets/icon/close.svg";
import { useLocation } from "react-router-dom";
import Col from "../../UIcomponent/Column";
const FirstVoucher = (props) => {
  const { hasToken } = props;
  const PageList = ["", "/", "/jointeacher"];
  const [visible, setVisible] = useState(false);
  const [pathname, setPathname] = useState("");
  const [copied, setCopied] = useState(false);
  const location = useLocation();
  const copyElement = useRef();

  const copyHandler = (e) => {
    e.preventDefault();
    copyElement.current.select();
    document.execCommand("copy", "Lingotalk");
    setCopied(true);
  };
  let path = location.pathname.toLowerCase();

  useEffect(() => {
    if (pathname !== path) {
      setPathname(path);
    }
    if (hasToken === false && PageList.includes(path)) {
      // setTimeout(() => {
      //   if (window.ga)
      //     window.ga("ec:addPromo", {
      //       id: "Lingotalk",
      //       name: "Lingotalk 20",
      //       creative: "pop_up",
      //     });
      //   setVisible(true);
      // }, 8000);
    }
  }, [path]);
  return (
    <>
      <Layout visible={visible}></Layout>
      <Container visible={visible}>
        <Title>20 هزار تومان تخفیف</Title>
        <Desc>ویژه رزرو اولین کلاس</Desc>
        <Help>با وارد کردن کد</Help>
        <CodeContainer>
          <CodeCopy onClick={copyHandler} copied={copied}>
            <CopyIcon />
          </CodeCopy>
          <CodeBox
            ref={copyElement}
            wrap="off"
            value={"Lingotalk"}
            readOnly={true}
          />
        </CodeContainer>
        <Action secondary>
          <StyledLink
            force
            to="/teachers"
            onClick={() => {
              setVisible(false);
            }}
          >
            مشاهده لیست اساتید
          </StyledLink>
        </Action>
      </Container>
      <DesignWrapper visible={visible}>
        <Close
          onClick={() => {
            setVisible(false);
          }}
        >
          <CloseIcon />
        </Close>
        <VoucherGraphic />
      </DesignWrapper>
    </>
  );
};

export default FirstVoucher;
